export const SET_DIVISION = "SET_DIVISION";
export const GET_DIVISION = "GET_DIVISION";
export const SET_BENCHMARK_ACHIEVED = "SET_BENCHMARK_ACHIEVED";
